/**
 * Detects whether window and document objects are available in current environment.
 */
export default typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
